module.exports = __webpack_public_path__ + "img/babel.1a4888fd.png";